import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Admin from './pages/Admin';
import Checkout from './pages/Checkout';
import EmailVerify from './pages/EmailVerify';
import Home from './pages/Home';
import Landing from './pages/Landing';
import OrderStatus from './pages/OrderStatus';
import GuideTicketDelivery from './pages/GuideTicketDelivery';
import MyTicket from './pages/MyTicket';
import Privacy from './pages/Privacy';
import StaffCheckin from './pages/StaffCheckin';
import StaffPos from './pages/StaffPos';
import Superadmin from './pages/Superadmin';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/checkout/:orderId" element={<Navigate to="/e/moonfield-fest" replace />} />
        <Route path="/order/:orderKey" element={<Navigate to="/e/moonfield-fest" replace />} />
        <Route path="/privacy" element={<Privacy />} />
        {/*
          TICK-093 — platform-level, not under `/e/:eventSlug`: a buyer's tickets span events, and
          nesting it under one would ask them to remember which event they are looking for before
          they can look for it.
        */}
        <Route path="/myticket" element={<MyTicket />} />
        {/* TICK-094 — organizer documentation, platform-level like the portal itself. */}
        <Route path="/guide/ticket-delivery" element={<GuideTicketDelivery />} />
        <Route path="/admin" element={<Navigate to="/e/moonfield-fest/admin" replace />} />
        <Route path="/staff/checkin" element={<Navigate to="/e/moonfield-fest/staff/checkin" replace />} />
        <Route path="/superadmin" element={<Superadmin />} />
        <Route path="/t/:token" element={<OrderStatus />} />
        {/* TICK-061: where an email Magic Link lands. Event-agnostic — the token identifies the order. */}
        <Route path="/verify/email/:token" element={<EmailVerify />} />

        {/* Any event provisioned from /superadmin, reachable by slug. */}
        <Route path="/e/:eventSlug" element={<Landing />} />
        <Route path="/e/:eventSlug/checkout/:orderId" element={<Checkout />} />
        <Route path="/e/:eventSlug/order/:orderKey" element={<OrderStatus />} />
        <Route path="/e/:eventSlug/admin" element={<Admin />} />
        <Route path="/e/:eventSlug/staff/checkin" element={<StaffCheckin />} />
        {/* TICK-078 — the counter. Its own role, because selling is not admitting. */}
        <Route path="/e/:eventSlug/staff/pos" element={<StaffPos />} />

        <Route path="*" element={<Navigate to="/e/moonfield-fest" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
